import { Component, Input, OnInit } from '@angular/core';
import { IReportEmbedConfiguration, models } from 'powerbi-client';
import { TokenPowerBI } from './interfaces/TokenPowerBI.interface';
import { PowerBiService } from './services/powerbi.service';

@Component({
  selector: 'app-powerbi-reporte',
  templateUrl: './powerbi-reporte.component.html',
  styleUrls: ['./powerbi-reporte.component.scss'],
})
export class PowerbiReporteComponent implements OnInit {
  @Input() nombreReporte: string = '';
  @Input() idReporte: string = '';
  @Input() filtro: string = '';
  @Input() reporSection: string = '';

  reportConfig: IReportEmbedConfiguration = {
    type: 'report',
    embedUrl: undefined,
    tokenType: models.TokenType.Embed,
    accessToken: undefined,
    settings: undefined,
  };

  reportClass = 'report-container hidden';

  constructor(public httpService: PowerBiService) {
    this.embedReport();
  }

  ngOnInit(): void {}

  async embedReport(): Promise<void> {
    this.reportConfig = {
      type: 'report',
      embedUrl: undefined,
      tokenType: models.TokenType.Embed,
      accessToken: undefined,
      settings: undefined,
    };

    let authTokenPowerBi: TokenPowerBI;
    try {
      authTokenPowerBi = await this.httpService.getAuthToken().toPromise();
      //authTokenPowerBi = await this.httpService.getAuthToken();

      this.httpService
        .getReportData(authTokenPowerBi.token, this.idReporte)
        .then((data) => {
          this.reportConfig = {
            type: 'report',
            id: data['id'],
            embedUrl: data['embedUrl'] + this.filtro,
            accessToken: authTokenPowerBi.token,
            tokenType: models.TokenType.Aad,
            pageName: this.reporSection,
            settings: {
              filterPaneEnabled: false,
              navContentPaneEnabled: false,
            },
          };
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error: any) {
      console.error(error);
    }
  }
}
